@file:OptIn(ExperimentalMaterial3Api::class)

package us.laantech.laanmanage.feature.store.pos.ui

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.text.input.TextFieldState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.luminance
import androidx.compose.ui.semantics.isTraversalGroup
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.traversalIndex
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp

@Preview
@Composable
fun ButtonConfigurationModalPreview() {
    ButtonConfigurationModal(PosEditorViewModel())
}

@Composable
fun ButtonConfigurationModal(viewModel: PosEditorViewModel) {

    val uiState by viewModel.uiState.collectAsState()


    BasicAlertDialog({  }) {

        Surface(
            shape = Shapes().large,
            modifier = Modifier.defaultMinSize(400.dp, 200.dp)
        ) {
            Column(modifier = Modifier.padding(8.dp)) {

                // Button function selection
//                var selectedIndex by remember { mutableIntStateOf(2) }

                FlowRow(modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceEvenly
                ) {
                    uiState.buttonOptions.forEachIndexed { index, label ->
                        FilterChip(
                            selected = index == uiState.selectedButtonFunction,
                            onClick = { viewModel.selectButtonFunction(index) },
                            label = { Text(label) }
                        )
                    }
                }

                // Department
                if (uiState.selectedButtonFunction == 0) {
                    SimpleSearchBar(
                        TextFieldState(),
                        onSearch = {
                            println("Search $it")
                        },
                        searchResults = mutableStateListOf(),
                    )
                }

                // Product
                if (uiState.selectedButtonFunction == 1) {

                }

                // Amount
                if (uiState.selectedButtonFunction == 2) {
                    TextField(uiState.labelTextFieldState,
                        label = { Text("Label") },
                        modifier = Modifier.fillMaxWidth()
                    )

                    val choices = listOf("Number Pad Amount", "Fixed Amount") // TODO amount types: entry, fixed, percent
                    SingleChoiceSegmentedButtonRow(modifier = Modifier.fillMaxWidth()) {
                        choices.forEachIndexed { index, label ->
                            SegmentedButton(
                                shape = SegmentedButtonDefaults.itemShape(
                                    index = index,
                                    count = choices.size
                                ),
                                onClick = { viewModel.configModalToggleIsFixedAmount() },
                                selected = (index > 0) == uiState.isFixedAmount,
                                label = { Text(label) }
                            )
                        }
                    }

                    if (uiState.isFixedAmount) {
                        TextField(uiState.amountTextFieldState,
                            label = { Text("Amount") },
                            modifier = Modifier.fillMaxWidth(),
                            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                        )
                    }

                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Text("Taxable")
                        Checkbox(
                            checked = uiState.isTaxable,
                            onCheckedChange = { viewModel.configModalToggleIsTaxable() }
                        )

                        Text("EBT")
                        Checkbox(
                            checked = uiState.canUseEBT,
                            onCheckedChange = { viewModel.configModalToggleCanUseEBT() }
                        )
                    }
                }

                // Select Color
                Text("Color")
                FlowRow(
                    horizontalArrangement = Arrangement.spacedBy(4.dp),
                ) {
                    PosButtonColors.entries.forEach { buttonColor ->
                        val isSelected = uiState.selectedButtonColor == buttonColor.name
                        FilterChip(
                            selected = isSelected,
                            onClick = { viewModel.selectButtonColor(buttonColor.name) },
                            label = { Text(buttonColor.name) },
                            colors = FilterChipDefaults.filterChipColors(
                                containerColor = buttonColor.color,
                                selectedContainerColor = buttonColor.color,
                                labelColor = if (buttonColor.color.luminance() > 0.5f) Color.Black else Color.White,
                                selectedLabelColor = if (buttonColor.color.luminance() > 0.5f) Color.Black else Color.White,
                            ),
                            border = FilterChipDefaults.filterChipBorder(
                                enabled = true,
                                selected = false,
                            )
                        )
                    }
                }




                // Button Preview
                ButtonPreview(viewModel)

            }
        }
    }
}


@Composable
fun ButtonPreview(viewModel: PosEditorViewModel) {
    val uiState by viewModel.uiState.collectAsState()
    Text("Preview")
    Button(
        onClick = { },
        shape = Shapes().large,
        modifier = Modifier.size(81.dp, 81.dp).aspectRatio(1f),
        contentPadding = PaddingValues(0.dp),
        colors = ButtonDefaults.buttonColors(
            containerColor = PosButtonColors.valueOf(uiState.selectedButtonColor).color,
            disabledContainerColor = PosButtonColors.valueOf(uiState.selectedButtonColor).color,
            contentColor = if (PosButtonColors.valueOf(uiState.selectedButtonColor).color.luminance() > 0.5f) Color.Black else Color.White,
            disabledContentColor = if (PosButtonColors.valueOf(uiState.selectedButtonColor).color.luminance() > 0.5f) Color.Black else Color.White,
        )
    ) {
        Text(text = "${uiState.labelTextFieldState.text}")
    }
}



@Composable
fun SimpleSearchBar(
    textFieldState: TextFieldState,
    onSearch: (String) -> Unit,
    searchResults: List<String>,
    modifier: Modifier = Modifier
) {
    // Controls expansion state of the search bar
    var expanded by rememberSaveable { mutableStateOf(false) }

    Box(
        modifier
            .fillMaxSize()
            .semantics { isTraversalGroup = true }
    ) {
        SearchBar(
            modifier = Modifier
                .align(Alignment.TopCenter)
                .semantics { traversalIndex = 0f },
            inputField = {
                SearchBarDefaults.InputField(
                    query = textFieldState.text.toString(),
                    onQueryChange = { textFieldState.edit { replace(0, length, it) } },
                    onSearch = {
                        onSearch(textFieldState.text.toString())
                        expanded = false
                    },
                    expanded = expanded,
                    onExpandedChange = { expanded = it },
                    placeholder = { Text("Search") }
                )
            },
            expanded = expanded,
            onExpandedChange = { expanded = it },
        ) {
            // Display search results in a scrollable column
            Column(Modifier.verticalScroll(rememberScrollState())) {
                searchResults.forEach { result ->
                    ListItem(
                        headlineContent = { Text(result) },
                        modifier = Modifier
                            .clickable {
                                textFieldState.edit { replace(0, length, result) }
                                expanded = false
                            }
                            .fillMaxWidth()
                    )
                }
            }
        }
    }
}